import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FadeIn } from './FadeIn';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';
interface FormData {
  nombre: string;
  telefono: string;
  correo: string;
  cobertura: string;
  salud: string;
}
export function FormCTASection() {
  const [formData, setFormData] = useState<FormData>({
    nombre: '',
    telefono: '',
    correo: '',
    cobertura: '',
    salud: ''
  });
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const [sending, setSending] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    try {
      const params = new URLSearchParams();
      params.append('full_name', formData.nombre);
      params.append('first_name', formData.nombre.split(' ')[0]);
      params.append('last_name', formData.nombre.split(' ').slice(1).join(' '));
      params.append('phone', formData.telefono);
      params.append('email', formData.correo);
      params.append('cobertura_deseada', formData.cobertura);
      params.append('condicion_salud', formData.salud);
      await fetch('https://services.leadconnectorhq.com/hooks/mm4XWU5oWtYb7RcmqRCk/webhook-trigger/0aaf2bd1-74e1-4377-b94f-4d4431e8f8b1', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params.toString()
      });
    } catch (err) {
      console.warn('Error enviando a GHL:', err);
    }
    window.location.href = 'https://thankyou.senioradvance.vidalityinsurance.com';
  };
  const coberturaOptions = ['$5,000 - $10,000', '$10,000 - $15,000', '$15,000 - $25,000', 'No estoy seguro, necesito ayuda'];
  const saludOptions = ['Sí, tengo algunas condiciones', 'No, estoy bien de salud', 'Prefiero hablarlo con un agente'];
  return <section id="formulario" className="py-[50px] md:py-[80px] px-6 bg-brand-black" data-id="element-29">
      <div className="max-w-[900px] mx-auto" data-id="element-30">
        {/* Headline */}
        <FadeIn data-id="element-31">
          <div className="text-center mb-12" data-id="element-32">
            <h2 className="text-[36px] md:text-[42px] font-bold text-white mb-6 leading-tight" data-id="element-33">
              Da El Primer Paso. <br data-id="element-34" />
              Tu Familia Te Lo Agradecerá.
            </h2>
            <p className="text-[18px] md:text-[20px] text-brand-gold max-w-2xl mx-auto" data-id="element-35">
              Un agente licenciado te contactará en menos de 24 horas. Sin
              presión. Sin compromiso.
            </p>
          </div>
        </FadeIn>

        {/* Form Container */}
        <FadeIn delay={0.2} data-id="element-36">
          <div className="max-w-[550px] mx-auto" data-id="element-37">
            <div className="bg-brand-darkGray border-2 border-brand-gold rounded-2xl p-8 md:p-10 shadow-[0_0_30px_rgba(245,166,35,0.2)]" data-id="element-38">
              {/* Form Header */}
              <div className="text-center mb-8" data-id="element-39">
                <h3 className="text-brand-gold font-bold text-[22px] md:text-[24px] mb-2" data-id="element-40">
                  🛡️ OBTÉN TU COTIZACIÓN GRATIS
                </h3>
                <p className="text-white text-[16px]" data-id="element-41">SIN COMPROMISO</p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-42">
                {/* Name */}
                <div data-id="element-43">
                  <div className="relative" data-id="element-44">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg" data-id="element-45">
                      👤
                    </span>
                    <input type="text" name="nombre" placeholder="Nombre Completo" value={formData.nombre} onChange={handleChange} required className="w-full bg-[#2A2A2A] border border-[#444444] rounded-lg h-[52px] pl-12 pr-4 text-[18px] text-white placeholder-[#888888] focus:border-brand-gold focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" data-id="element-46" />
                  </div>
                </div>

                {/* Phone */}
                <div data-id="element-47">
                  <div className="relative" data-id="element-48">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg" data-id="element-49">
                      📱
                    </span>
                    <input type="tel" name="telefono" placeholder="Número de Teléfono" value={formData.telefono} onChange={handleChange} required className="w-full bg-[#2A2A2A] border border-[#444444] rounded-lg h-[52px] pl-12 pr-4 text-[18px] text-white placeholder-[#888888] focus:border-brand-gold focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" data-id="element-50" />
                  </div>
                </div>

                {/* Email */}
                <div data-id="element-51">
                  <div className="relative" data-id="element-52">
                    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-lg" data-id="element-53">
                      📧
                    </span>
                    <input type="email" name="correo" placeholder="Correo Electrónico" value={formData.correo} onChange={handleChange} required className="w-full bg-[#2A2A2A] border border-[#444444] rounded-lg h-[52px] pl-12 pr-4 text-[18px] text-white placeholder-[#888888] focus:border-brand-gold focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" data-id="element-54" />
                  </div>
                </div>

                {/* Coverage Question */}
                <div className="pt-4" data-id="element-55">
                  <p className="text-white font-semibold text-[17px] mb-4" data-id="element-56">
                    ¿Cuánta cobertura te interesa?
                  </p>
                  <div className="space-y-3" data-id="element-57">
                    {coberturaOptions.map((option, index) => <label key={index} className="flex items-center gap-3 cursor-pointer group" data-id="element-58">
                        <div className="relative shrink-0" data-id="element-59">
                          <input type="radio" name="cobertura" value={option} checked={formData.cobertura === option} onChange={handleChange} className="sr-only peer" data-id="element-60" />
                          <div className="w-6 h-6 rounded-full border-2 border-[#555555] peer-checked:border-brand-gold transition-colors" data-id="element-61"></div>
                          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-brand-gold scale-0 peer-checked:scale-100 transition-transform" data-id="element-62"></div>
                        </div>
                        <span className="text-white text-[17px] group-hover:text-brand-gold transition-colors" data-id="element-63">
                          {option}
                        </span>
                      </label>)}
                  </div>
                </div>

                {/* Health Question */}
                <div className="pt-4" data-id="element-64">
                  <p className="text-white font-semibold text-[17px] mb-4" data-id="element-65">
                    ¿Tienes alguna condición de salud actualmente?
                  </p>
                  <div className="space-y-3" data-id="element-66">
                    {saludOptions.map((option, index) => <label key={index} className="flex items-center gap-3 cursor-pointer group" data-id="element-67">
                        <div className="relative shrink-0" data-id="element-68">
                          <input type="radio" name="salud" value={option} checked={formData.salud === option} onChange={handleChange} className="sr-only peer" data-id="element-69" />
                          <div className="w-6 h-6 rounded-full border-2 border-[#555555] peer-checked:border-brand-gold transition-colors" data-id="element-70"></div>
                          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-brand-gold scale-0 peer-checked:scale-100 transition-transform" data-id="element-71"></div>
                        </div>
                        <span className="text-white text-[17px] group-hover:text-brand-gold transition-colors" data-id="element-72">
                          {option}
                        </span>
                      </label>)}
                  </div>
                </div>

                {/* Submit Button */}
                <div className="pt-4" data-id="element-73">
                  <button type="submit" className="w-full bg-brand-gold hover:bg-[#FFB733] text-black font-bold text-[16px] md:text-[20px] min-h-[58px] py-4 px-4 rounded-[10px] shadow-[0_4px_15px_rgba(245,166,35,0.4)] hover:shadow-[0_6px_20px_rgba(245,166,35,0.6)] transition-all duration-300 hover:-translate-y-0.5 leading-tight" data-id="element-74">
                    👇 QUIERO MI COTIZACIÓN GRATIS AHORA
                  </button>
                </div>

                {/* Security Text */}
                <div className="flex items-center justify-center gap-2 text-[14px] text-[#AAAAAA] pt-2" data-id="element-75">
                  <Lock className="w-4 h-4 text-brand-gold" data-id="element-76" />
                  <span data-id="element-77">
                    Tu información está 100% segura. No compartimos tus datos
                    con nadie.
                  </span>
                </div>
              </form>
            </div>

            {/* Legal Disclaimer */}
            <p className="text-[#666666] text-[12px] text-center mt-6 max-w-md mx-auto" data-id="element-78">
              Al enviar este formulario autorizas a un agente licenciado a
              contactarte por teléfono o correo electrónico para brindarte
              información sobre pólizas de seguro de vida Final Expense. No se
              requiere compra.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}